import { Component, AfterViewInit, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import * as $ from 'jquery';
import '@progress/kendo-ui';
import './kendo-ui-license.js'
import { SelectedExamDetailService } from '../../../scheduling/shared/services/selected-exam-detail.service';
import { BootstrapParams } from '../../../../bootstrap-params';

@Component({
    selector: 'app-captcha',
    templateUrl: './captcha.component.html',
    styleUrls: ['./captcha.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CaptchaComponent implements AfterViewInit {
    public captcha: any;
    public showInvalidCaptchaMessage = false;
    public captchaText: string = "";
    public captchaEnable: boolean;

    constructor(private selectedExamDetailService: SelectedExamDetailService,
        private bootstrapParams: BootstrapParams) {
        this.selectedExamDetailService.setUserCaptchInput('');
        this.selectedExamDetailService.setCaptchaValidationResult(false);
        this.captchaEnable = this.bootstrapParams.captchaEnable;
    }

    ngAfterViewInit(): void {
        const orchestrationRootApiUrl = this.bootstrapParams.OrchestrationRootApiUrl;
        const sessionGuid = this.bootstrapParams.sessionGuid;

        this.captcha = $("#captcha").kendoCaptcha({
            handler: (args: any) => {
                $.ajax({
                    url: orchestrationRootApiUrl + "api/v1/captcha/reset",
                    headers: { "Sessionid": sessionGuid },
                }).done((result) => {
                    var captchaPath = result.captcha;
                    var captchaId = result.captchaId;
                    $.ajax({
                        url: captchaPath,
                        headers: { "Sessionid": sessionGuid },
                        xhr: () => {
                            var xhr = new XMLHttpRequest();
                            xhr.onreadystatechange = () => {
                                if (xhr.readyState == 2) {
                                    if (xhr.status == 200) {
                                        xhr.responseType = "blob";
                                    }
                                }
                            };
                            return xhr;
                        },
                    }).done((data: any) => {
                        this.showInvalidCaptchaMessage = false;
                        this.captchaText = "";
                        this.selectedExamDetailService.setUserCaptchInput('');
                        this.selectedExamDetailService.setCaptchaValidationResult(false);
                        var reader = new FileReader();
                        reader.readAsDataURL(data);
                        reader.onloadend = () => {
                            args.success({
                                captcha: reader.result,
                                captchaId: captchaId
                            });
                        }

                    });
                });
            },
            audioHandler: (args: any) => {
                $.ajax({
                    url: orchestrationRootApiUrl + "api/v1/captcha/audio",
                    headers: { "Sessionid": sessionGuid },
                    data: { id: args.data.captchaId },
                    xhr: function () {
                        var xhr = new XMLHttpRequest();
                        xhr.onreadystatechange = () => {
                            if (xhr.readyState == 2) {
                                if (xhr.status == 200) {
                                    xhr.responseType = "blob";
                                }
                            }
                        };
                        return xhr;
                    },
                }).done((data: any) => {
                    var blob = new Blob([data], {type: 'audio/wav'});
                    var url = URL.createObjectURL(blob);
                    args.success(url);
                });
            },
            validationHandler: (args: any) => {
                $.ajax({
                    url: orchestrationRootApiUrl + "api/v1/captcha/validate",
                    headers: { "Sessionid": sessionGuid },
                    data: args.data
                }).done((data: any) => {
                    args.success(data);
                });
            }
        }).data("kendoCaptcha");
    }

    trackInput(event: any): void {
        this.showInvalidCaptchaMessage = false;
        this.selectedExamDetailService.setUserCaptchInput(event.target.value);
    }

    validateCaptcha() {
        this.captcha.validate().done((isValid: any) => {
            this.showInvalidCaptchaMessage = !isValid;
            this.selectedExamDetailService.setCaptchaValidationResult(isValid);
        });
    }
}
